import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "form-image-preview" */'./FormImagePreview').then(mod => mod.default).catch(AsyncComponentErrorHandler('form-image-preview')),
  LoadingComponent: () => null
});